var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRobotIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Robot_icon",
    d: "M13,4.055A9,9,0,0,1,21,13v9H3V13a9,9,0,0,1,8-8.945V1h2V4.055ZM12,18a5,5,0,1,0-5-5A5,5,0,0,0,12,18Zm0-2a3,3,0,1,1,3-3A3,3,0,0,1,12,16Zm0-2a1,1,0,1,0-1-1A1,1,0,0,0,12,14Z",
    transform: "translate(-3 -1)",
    fill: "#34a3dc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotIcon);
export default __webpack_public_path__ + "static/media/Robot_icon.e9dc56c54fbbfc54ce9fbf52d0c0f805.svg";
export { ForwardRef as ReactComponent };